import { Component, OnInit, ViewChild, Input, AfterViewInit, ElementRef } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService, SortMeta } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { AppMainComponent } from 'src/app/app.main.component';
import { Statut } from 'src/app/entites/statut';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { enrichirRechercheEmploye } from 'src/app/entites/employe';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AchatService } from 'src/app/services/achat-service';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { TypeBonTravail } from 'src/app/entites/mecanique/type-bon-travail';
import { ETypeBonTravail } from 'src/app/entites/enums/type-bon-travail'
import { SignalWithWatcher } from "src/app/services/base.service";
import { COLONNES_DISPONIBLES_BONS_TRAVAIL } from './bons-travail-colonnes';

@Component({
    templateUrl: './bons-travail.component.html',
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService],
})
export class BonsTravailComponent extends BaseComponent implements OnInit, AfterViewInit {

    liste: SignalWithWatcher<BonTravailEntite[]>;
    selectionBonTravail: BonTravailEntite;

    tableParams = this.createTableFilter();
    globalFilter: string = '';

    menuContextuelEntrees: MenuItem[];

    sortMeta: SortMeta[] = [
        { field: 'indArchive', order: 1 },
        { field: 'dateTravail', order: -1 },
    ];

    detailBdtId: number;
    afficherDetailBdt: boolean = false;

    statuts: Statut[] = this.sdb.Statuts();
    types: TypeBonTravail[] = [{
        id_type_bon_travail: ETypeBonTravail.Interne,
        nom: 'Interne'
    }, {
        id_type_bon_travail: ETypeBonTravail.Externe,
        nom: 'Externe'
    }, {
        id_type_bon_travail: ETypeBonTravail.Chantier,
        nom: 'Chantier'
    }];

    menuContextuel: MenuItem[];

    @ViewChild('dt') table: Table;
    @ViewChild('rechercheBdt') rechercheBdt: ElementRef;
    @ViewChild('menuContextuelItemCommande') menuContextuelItemCommande: ContextMenu;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, location: Location,
        private breadcrumbService: BreadcrumbService,
        private bonTravailService: BonTravailService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {

        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Bons de travail' }
        ]);
    }

    ngOnInit() {

        this.verifierAccesPageAuMoisUnAcces(['bonstravail', 'temp_mec']);

        this.colonnesDisponibles = COLONNES_DISPONIBLES_BONS_TRAVAIL;
        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.bonTravailService.Obtenir(this.routerService.url.includes('soumissions')).subscribe(x => {
            this.liste = x;
            this.enrichirRechercheEmployes();
            this.CompleterChargement();
            setTimeout(() => this.rechercheBdt.nativeElement.focus(), 100);
        });
    }

    /**
     * Enrichit les employés des bons de travail avec les champs de recherche dérivés
     * (initiales, prenomNom, recherche) pour permettre le filtrage par initiales.
     */
    enrichirRechercheEmployes() {
        this.liste?.value()?.forEach(bdt => {
            enrichirRechercheEmploye(bdt.contreMaitre);
            enrichirRechercheEmploye(bdt.mecanicien);
        });
    }

    ngAfterViewInit() {
        this.globalFilter = this.tableParams.getValue().globalFilter;
        if (this.tableParams.getValue().multiSortMeta) {
            this.sortMeta = this.tableParams.getValue().multiSortMeta;
        }
        this.chargerColonnesSelectionnees();
    }

    surMenuContextuelItem(event, bonTravail: BonTravailEntite) {
        this.selectionBonTravail = bonTravail;

        this.menuContextuelEntrees = [
            {
                label: 'Voir l\'unité',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl('item/' + bonTravail.item.itemId)
            },
            {
                label: 'Voir le fournisseur',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('fournisseur_detail'),
                command: () => this.routerService.navigateByUrl('fournisseur/' + bonTravail.fournisseur.fournisseurId)
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-times',
                visible: (this.estAutorise('bontravail_supprimer') || this.estAutorise('temp_mec')),
                disabled: bonTravail.statut.statutId != EStatuts.EnCours && bonTravail.statut.statutId != EStatuts.EnAttente,
                styleClass: 'menuSuppression',
                command: () => this.supprimerBonTravail(bonTravail)
            }
        ];

        this.menuContextuelItemCommande.toggle(event);
    }

    supprimerBonTravail(bonTravail: BonTravailEntite) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer le bon de travail sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.bonTravailService.Supprimer(bonTravail.bonTravailId).then(res => {
                    if (res.estUnSucces) {
                        this.liste.value.set(this.liste.value().filter(val => val.bonTravailId != bonTravail.bonTravailId));
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    AjouterBdt() {
        this.routerService.navigateByUrl("mecanique/soumissions/nouveau")
    }

    OuvrirDetailBdt(bonTravailId: number) {
        this.routerService.navigateByUrl(`mecanique/${this.routerService.url.includes('soumissions') ? 'soumissions' : 'bontravails'}/${bonTravailId}`)
    }

    OuvrirAnalyseBdt(bonTravail: BonTravailEntite) {
        this.routerService.navigateByUrl(`mecanique/analyses/${bonTravail.analyseBonTravail?.analyseBonTravailId}`)
    }

    OuvrirDetailBdtNouvelOnglet(itemId: number) {
        this.appMain.detailBonTravailId = itemId;
        this.appMain.afficherDetailBonTravail = true;
    }

    clearFilters(table: Table) {
        table.reset();
        table.clear();
        this.globalFilter = '';
        this.sortMeta = [
            { field: 'indArchive', order: 1 },
            { field: 'dateTravail', order: -1 },
        ];
        this.tableParams.setValue(table);
    }
}
